import styled from "styled-components";

export default function HeartIcon() {
  return <StyledHeartIcon src="image/heart.png" />;
}

const StyledHeartIcon = styled.img`
  width: 15px;
`;
